export default __webpack_public_path__ + "7677afa1551f6dafe75fcec4ef472f08.png";